import { render, staticRenderFns } from "./FPagination.vue?vue&type=template&id=3405ce11&"
import script from "./FPagination.vue?vue&type=script&lang=js&"
export * from "./FPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports